<template>
  <div id="pro" class="w-full min-h-screen bg-gray-1000 h-full">
    <NuxtPage />
  </div>
</template>
